export default "__VITE_ASSET__DAniaQiv__"